import { apiRequest } from '../apiRequest';

export const bulkHardDeleteLeadsApi = async (leadIds) => {
    return apiRequest('/admin/lead/leads/bulk-hard-delete', {
        method: 'DELETE',
        body: { lead_ids: leadIds },
        defaultErrorMessage: 'Failed to permanently delete selected leads',
    });
};
